//language identifiers are not the same as the doc paths (/docs/en/Workbench/screens/inbound.html for example) 
export const lgDocPath = {
  en_US: 'en',
  en_SG: 'en',
  ja_JP: 'jp'
}